<template>
	<sf-modal-layout size="xl" :show="show" :closeModal="close">
		<div class="user-managment-items-container">
			<div>hihi</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="() => close()">{{ getMessage_('MWCC000343') }}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/PartsInfo/store/helpers';
export default {
	props: { popup2: { type: Boolean, default: false } },
	data() {
		return {
			show: this.popup2
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open() {
			this.show = true;
		},
		close() {
			this.show = false;
		}
	}
};
</script>

<style scoped>
.user-managment-items-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
</style>
